export default Object.freeze({
  ScopeRole: 1,
  ScopeUserId: 2,
  ScopePositionId: 3,
  ScopeAreaId: 4,
  ScopeUserGroupId: 5,
  ScopeAppClientId: 6,
  ScopeAppId: 7,
  ScopePortalId: 8,
  IpSingle: 9,
  IpRange: 10,
  IpCidr: 11,
  GeoCountryCode: 12,
  GeoState: 13,
  GeoCity: 14,
  UserAgent: 15,
  DeviceKnown: 16,
});
